import type { ShirtColor } from '../types';

export type ColorMeta = {
  label: string;
  swatch: string;
  stroke: string;
  // CSS filter applied to the printed logo so it stays legible against `swatch`.
  // 'none' = use logo as-is (works on dark fabric).
  logoFilter: string;
};

export const COLOR_META: Record<ShirtColor, ColorMeta> = {
  'czarna': {
    label: 'CZARNA',
    swatch: '#0E0807',
    stroke: '#000',
    logoFilter: 'none',
  },
  'biała': {
    label: 'BIAŁA',
    swatch: '#F4ECDD',
    stroke: '#1A100B',
    logoFilter: 'invert(.85) sepia(1) hue-rotate(-20deg) saturate(2.5)',
  },
};
